import { render, staticRenderFns } from "./CardCompany.vue?vue&type=template&id=20dd7558&scoped=true&"
import script from "./CardCompany.vue?vue&type=script&lang=js&"
export * from "./CardCompany.vue?vue&type=script&lang=js&"
import style0 from "./CardCompany.vue?vue&type=style&index=0&id=20dd7558&scoped=true&lang=css&"
import style1 from "./CardCompany.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd7558",
  null
  
)

export default component.exports